<script>
import StockAwareStoreResults from '@maison/components/store/StockAwareStoreResults.vue';
import boutiqueStockAvailabilityModal from '@phoenix/mixins/components/product/boutiqueStockAvailabilityModal';

export default {
  components: { StockAwareStoreResults },

  mixins: [boutiqueStockAvailabilityModal],

  props: {
    bsaodWatchTypeText: {
      type: String,
      required: false,
      default: '',
    },
  },

  computed: {
    subtitle() {
      return `${this.collectionTitle} ${this.productTitle} ${this.modelReference}`;
    },

    watchTypeText() {
      return this.isFallbackReferenceForCountry && this.hasStock(this.storesForCountry)
        ? this.$t('BSAOD.explanation.edged')
        : this.bsaodWatchTypeText;
    },
  },

  mounted() {
    this.fields.reference.value = this.references[0].value;
  },

  methods: {
    hasStock(stores) {
      return stores.some((store) => store.hasStock);
    },
  },
};
</script>

<template>
  <modal :id="id" :title="modalTitle" :subtitle="subtitle" :options="modalOptions" header-bordered naked>
    <template #header>
      <p
        v-show="watchTypeText.length > 0"
        class="p-base"
        data-cy="boutique-stock-availability-watch-type-text"
        v-html="watchTypeText"
      />
    </template>

    <template #content>
      <div class="store-finder-modal__autocomplete">
        <phoenix-form
          v-if="isShown"
          v-model="fields"
          :should-display-required-text="false"
          :is-boxed="false"
          :should-display-submit-button="false"
          :is-contained="false"
          data-cy="boutique-stock-availability-form"
          @submit.prevent="submit"
        >
          <form-group :attrs="fields.country" class="form-field store-finder-modal__search-title" :show-label="false">
            <h5 class="store-finder-modal__search-title">
              {{ fields.country.label }}
              <abbr :title="$t('Form.required')" data-cy="form-input-required">*</abbr>
            </h5>
            <select-field v-model="fields.country.value" />
          </form-group>
        </phoenix-form>
      </div>

      <stock-aware-store-results
        :stores="storesForCountry"
        :is-loading="isLoading"
        :reference="fields.reference.value"
        :display-no-result="formSubmitted"
        :display-stock="shouldDisplayStockForCountry"
        :no-result-title="noResultTitle"
        :no-result-text="noResultText"
        :no-result-c-t-a="noResultCTA"
        :follow-store-link-on-click="false"
        @store-click="storeClick"
      />
    </template>
  </modal>
</template>
